import React , {useState,useEffect} from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import { Typography } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {get_orders} from '../../services/profileService'

const columns = [


  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'code', label: 'ISO\u00a0Code', minWidth: 100 },
  {
    id: 'population',
    label: 'Population',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'size',
    label: 'Size\u00a0(km\u00b2)',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'density',
    label: 'Density',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toFixed(2),
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
  createData('India', 'IN', 1324171354, 3287263),
  createData('China', 'CN', 1403500365, 9596961),
  createData('Italy', 'IT', 60483973, 301340),
  createData('United States', 'US', 327167434, 9833520),
  createData('Canada', 'CA', 37602103, 9984670),
  createData('Australia', 'AU', 25475400, 7692024),
  createData('Germany', 'DE', 83019200, 357578),
  createData('Ireland', 'IE', 4857000, 70273),
  createData('Mexico', 'MX', 126577691, 1972550),
  createData('Japan', 'JP', 126317000, 377973),
  createData('France', 'FR', 67022000, 640679),
  createData('United Kingdom', 'GB', 67545757, 242495),
  createData('Russia', 'RU', 146793744, 17098246),
  createData('Nigeria', 'NG', 200962417, 923768),
  createData('Brazil', 'BR', 210147125, 8515767),
];

const ProfileOrderTable = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tableData,setTableData] = useState([])

  useEffect(()=>{
    async function fetchOrderData(){
        try{
            let data = JSON.parse(sessionStorage.getItem('user'))
            let send_data = {
                "id":parseInt(data['id'])
            }
            console.log("Send Data => " , send_data)
            const response = await get_orders(send_data)
            // console.log(response)
            setTableData(response)
        }
        catch(error){
            console.error("Error Occured on getting Order Data => " , error);

        }
    }
    fetchOrderData();
  },[])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>   
                <TableCell>S.No</TableCell>
                <TableCell>Number</TableCell>
                <TableCell>Order Type</TableCell>
                <TableCell>Delivered Address</TableCell>
              
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((items,index)=>{
                return (
                    <TableRow>
                        <TableCell>{index+1}</TableCell>
                        <TableCell>{items.order_number}</TableCell>
                        <>
                        <TableCell> <Typography 
                        sx={{
                            bgcolor: items.order_type === 'delivery' ? "red" : "blue",
                            width:'50%',
                            textAlign:'center',
                            borderRadius:'25px',
                            color:'white'
                            }}>{items.order_type.toUpperCase()}</Typography></TableCell>
                        </>
                        
                        <TableCell>{items.delivery_address}</TableCell>
                    </TableRow>
                )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default ProfileOrderTable;